module.exports = __webpack_public_path__ + "img/a.9f2311e0.svg";